import { buildQueryString } from '@izimi/utils';

import type FetchService from '../FetchService';
import type {
  ApiRequestBodyType,
  ApiRequestPathParamType,
  ApiRequestQueryParamType,
  ApiResponseType,
} from '../types';
import type { ApiContact } from './types';

class ContactsApi {
  constructor(private fetchService: FetchService) {}

  getContacts(params?: ApiRequestQueryParamType<'listContacts'>) {
    const qs = buildQueryString(params);
    return this.fetchService.get<ApiContact[]>(`/contacts${qs}`);
  }

  getContactsV2(params?: ApiRequestQueryParamType<'getPaginatedContacts'>) {
    const qs = buildQueryString(params);
    return this.fetchService.get<ApiResponseType<'getPaginatedContacts'>>(`/v2/contacts${qs}`);
  }

  inviteContact({ emailAddress }: ApiRequestBodyType<'addContact'>) {
    return this.fetchService.post<ApiResponseType<'addContact'>>('/contacts', {
      emailAddress,
    });
  }

  deleteContact({ contactId }: ApiRequestPathParamType<'deleteContact'>) {
    return this.fetchService.delete<ApiResponseType<'deleteContact'>>(`/contacts/${contactId}`);
  }

  acceptContactRequest({ contactId }: ApiRequestPathParamType<'acceptContact'>) {
    return this.fetchService.put<ApiContact>(`/contacts/${contactId}/accept`);
  }

  rejectContactRequest({ contactId }: ApiRequestPathParamType<'rejectContact'>) {
    return this.fetchService.put<ApiResponseType<'rejectContact'>>(`/contacts/${contactId}/reject`);
  }
}

export default ContactsApi;
